import { arrWeekdays, arrWeekdaysShort } from '../data';

var getOpeningHours = function getOpeningHours(_ref) {
  var jsonOpeningHours = _ref.jsonOpeningHours;
  var strTxt = '';
  var iDayOfTheWeek = 0;
  var arrOpeningHours = [];
  arrWeekdays.forEach(function (strWeekday) {
    Object.keys(jsonOpeningHours).map(function (iKey) {
      if (iKey === strWeekday) {
        if (jsonOpeningHours[iKey]) {
          arrOpeningHours.push([arrWeekdaysShort[iDayOfTheWeek], jsonOpeningHours[iKey][0], jsonOpeningHours[iKey][1]]);
        } else {
          arrOpeningHours.push([arrWeekdaysShort[iDayOfTheWeek], '00h00', '00h00']);
        }

        iDayOfTheWeek += 1;
      }

      return iKey;
    });
  });
  var arrBackupOpen = arrOpeningHours[0][1];
  var arrBackupClosure = arrOpeningHours[0][2];
  var strFirstDay = arrOpeningHours[0][0];

  for (var i = 0; i < 7; i += 1) {
    if (arrOpeningHours[i][1] !== arrBackupOpen || arrOpeningHours[i][2] !== arrBackupClosure) {
      if (strFirstDay !== arrOpeningHours[i - 1][0]) {
        strTxt += strFirstDay + " t.e.m. " + arrOpeningHours[i - 1][0] + " (" + arrOpeningHours[i - 1][1].replace('h', 'u') + "-" + arrOpeningHours[i - 1][2].replace('h', 'u') + ")<br />";
      } else if (arrOpeningHours[i - 1][1] !== '00h00' && arrOpeningHours[i - 1][2] !== '00h00') {
        strTxt += arrOpeningHours[i - 1][0] + " (" + arrOpeningHours[i - 1][1].replace('h', 'u') + "-" + arrOpeningHours[i - 1][2].replace('h', 'u') + ")<br />";
      }

      strFirstDay = arrOpeningHours[i][0];
    }

    arrBackupOpen = arrOpeningHours[i][1];
    arrBackupClosure = arrOpeningHours[i][2];
  }

  strTxt = strTxt.slice(0, -6);
  return strTxt;
};

export default getOpeningHours;